import { Box, BoxProps } from '@chakra-ui/react';
import { gradients } from '../../theme';

export const ProminentButtonBorder = (boxProps: BoxProps) => (
  <Box
    borderRadius="inherit"
    bgGradient={gradients.linearProminentBorder}
    backgroundPosition="center"
    {...boxProps}
  />
);
